import { Controller } from "@hotwired/stimulus"

const EVENT = "module_viewed"

export default class extends Controller {
  static values = { surface: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.track()
      },
      { rootMargin: "0px 0px -25% 0px" },
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  track() {
    this.observer.disconnect()

    window.posthog?.capture(EVENT, { surface: this.surfaceValue })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: EVENT, surface: this.surfaceValue })
  }
}
